import { GUI } from 'dat.gui'
import { BlendFunction, TextureEffect } from 'postprocessing'
import { TextureMapping } from '../../../../../trillion-common/src/objects/posteffects/texture-mapping.object'

import { StoreScheme } from '../../../shared/store/store'

export function addTextureGUI(gui: GUI, textureEffect: TextureEffect, store: StoreScheme) {
  const setTextureMapping = store.getState().setTextureMapping

  const textureMappingFolder = gui.addFolder('TextureMapping')
  textureMappingFolder.close()

  const textureMappingOptions = {
    blendFunction: textureEffect.blendMode.blendFunction,
  }

  textureMappingFolder
    .add(textureMappingOptions, 'blendFunction', BlendFunction)
    .name('blend mode')
    .onChange((value: number) => {
      const numValue = Number(value)
      textureEffect.blendMode.blendFunction = numValue
      updateTextureEffect((textureMapping) => {
        textureMapping.blendFunction = numValue
      })
    })

  function updateTextureEffect(updateCallback: (textureMapping: TextureMapping) => void) {
    updateCallback(textureMappingOptions)
    setTextureMapping(textureMappingOptions)
  }

  setTextureMapping(textureMappingOptions)
}
